(() => {
  async function initMap(element) {
    if (element.dataset.initialized || !window.L) return;
    element.dataset.initialized = 'true';
    const taxon = element.dataset.taxon;
    const center = element.dataset.center.split(',').map(Number);
    const status = element.parentElement.querySelector('.map-status');
    const fallback = element.querySelector('.map-fallback');
    const map = L.map(element, { scrollWheelZoom: false, maxZoom: 10 }).setView(center, Number(element.dataset.zoom));
    if (fallback) fallback.remove();
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap contributors</a>'
    }).addTo(map);
    const layer = L.tileLayer(`https://api.inaturalist.org/v1/grid/{z}/{x}/{y}.png?taxon_id=${encodeURIComponent(taxon)}&quality_grade=research&captive=false&geo=true`, {
      opacity: 0.85, maxZoom: 10, attribution: '<a href="https://www.inaturalist.org">iNaturalist observations</a>'
    }).addTo(map);
    layer.on('tileerror', () => { status.textContent = 'Some observation tiles could not load. Use the iNaturalist link to explore the records.'; });
    try {
      const url = `https://api.inaturalist.org/v1/observations?taxon_id=${encodeURIComponent(taxon)}&quality_grade=research&captive=false&geo=true&per_page=0`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Observation count unavailable');
      const data = await response.json();
      if (typeof data.total_results === 'number') status.textContent = `${data.total_results.toLocaleString()} mapped research-grade wild observations · live iNaturalist data`;
    } catch (error) { /* The map remains usable if the optional count request fails. */ }
  }
  function discover() {
    const elements = document.querySelectorAll('.observation-map[data-taxon]');
    if (!('IntersectionObserver' in window)) { elements.forEach(initMap); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { initMap(entry.target); observer.unobserve(entry.target); }
    }), { rootMargin: '200px' });
    elements.forEach(element => observer.observe(element));
  }
  discover();
  document.addEventListener('shopify:section:load', discover);
})();
